export const AppInfo = {
  domaine: 'sytrader.net',
  name: 'Sytrader',
  description: 'sytrader is a... ',
  slogan: '',
  website: 'https://sytrader.net',
  contact: {
    email: 'contact@sytrader.net',
    tel: '',
    fixe: '',
  },
  socials: {
    facebook: 'https://www.facebook.com/',
    twitter: 'https://www.twitter.com/',
    instagram: 'https://www.instagram.com/',
  },
  adresses: {
    pays: 'Gambie',
    ville: 'Banjul',
    rue: '',
  }
};
